<template>
    <div>
        <h1>Credentials</h1>
        <div class="card mt-5">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h5>Client ID</h5>
                <button type="button" class="btn btn-sm btn-default" @click="copy('clientId')" v-text="label('clientId')"></button>
            </div>
            <div class="card-body">
                <p class="card-text code">{{ clientId }}</p>
            </div>
        </div>
        <div class="card mt-5">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h5>Client secret</h5>
                <button type="button" class="btn btn-sm btn-default" @click="copy('clientSecret')" v-text="label('clientSecret')"></button>
            </div>
            <div class="card-body">
                <p class="card-text code">{{ clientSecret }}</p>
            </div>
        </div>
        <div class="card mt-5" v-if="showCode">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h5>Authorization code</h5>
                <button type="button" class="btn btn-sm btn-default" @click="copy('code')" v-text="label('code')"></button>
            </div>
            <div class="card-body">
                <p class="card-text code">{{ code }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Credentials",

    props: {
        showCode: false,
        code: {
            type: String,
            required: true
        },
        clientId: {
            type: String,
            required: true
        },
        clientSecret: {
            type: String,
            required: true
        },
    },

    data() {
        return {
            copied: {
                code: false,
                clientId: false,
                clientSecret: false,
            }
        }
    },

    methods: {
        async copy(source) {
            try {
                await this.$copyText(this[source]);
                this.copied[source] = true;
            } catch (error) {
                window.console.error(error);
            }
        },

        label(source) {
            return this.copied[source] ? 'Copied' : 'Copy';
        }
    }
}
</script>

<style scoped>
div.code {
    color: #000;
    border-radius: 10px;
    background-color: #dfebf1;
    padding: 20px;
    font-family: monospace;
    word-break: break-word;
    overflow-wrap: break-word;
}
.code {
    color: #000;
    font-family: monospace;
}
</style>



// WEBPACK FOOTER //
// src/components/Auth/Credentials.vue